// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","primary":"#56CCF2","module":"_3FD5OnPaYmwTSBH3VDOggV"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Congratulation/Congratulations.mod.css
// module id = 1586
// module chunks = 0